<template>
  <div>
    <div class="content">
      <div class="innerTitle">
        <el-button type="primary" size="small" @click="add">新增</el-button>
        <div class="screenBox">
          <el-select v-model="searchForm.type" placeholder="请选择类型" size="small" @change="selectChange" style="width: 47%" clearable>
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select v-model="searchForm.status" size="small" style="width: 47%" placeholder="请选择级别" @change="selectChange" clearable>
            <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </div>
      </div>
      <div class="tableBox">
        <el-table
        :data="tableData"
        border
        :header-cell-style="{ background: 'rgb(232,232,232)', height: '55px', textAlign: 'center' }"
        :row-style="{ height: '55px' }"
        :cell-style="{ textAlign: 'center' }"
        style="width: 100%">
        <el-table-column
          type="index"
          :index='(index) => {return index + 1 + (curPage-1)*limit}'
          label="序号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="indicatorNumber"
          label="目标指标编号">
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型">
          <template slot-scope="{ row }">
            {{ typeList[row.type].name }}
          </template>
        </el-table-column>
        <el-table-column
          prop="year"
          label="年度" />
          <el-table-column
          prop="dutyDepName"
          label="责任部门" />
          <el-table-column
          prop="dutyPersonName"
          label="责任人" />
        <el-table-column
          prop="completionDate"
          width="100"
          label="完成期限">
          <template slot-scope="{ row }">
            <span v-if="row.completionDate">{{ row.completionDate | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="producerDepName"
          label="制定部门">
        </el-table-column>
        <el-table-column
          prop="producer"
          width="100"
          label="制定人" />
        <el-table-column
          label="制定时间"
          width="100"
          prop="creationTime">
          <template slot-scope="{ row }">
            <span v-if="row.creationTime">{{ row.creationTime | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="objExaCriterionName"
          label="考核标准">
        </el-table-column>
        <el-table-column
          prop="examinationTime"
          width="100"
          label="考核时间">
          <template slot-scope="{ row }">
            <span>{{ row.examinationTime | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态">
          <template slot-scope="{ row }">
            {{ statusList[row.status].name }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="{ row }">
            <el-link type="primary" style="margin-right: 10px" @click="edit(row)" v-if="row.status === 0">编辑</el-link>
            <el-link type="primary" style="margin-right: 10px" @click="detail(row.id)">{{ row.status >= 3 ? '详情' : '审批' }}</el-link>
            <el-link type="primary" style="margin-right: 10px" @click="examine(row)" v-if="row.status === 3">考核</el-link>
            <el-link type="danger" @click="deleteList(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 15px; text-align: right">
        <Page :total='total' :page-size='limit' :current='curPage' @on-change='curPageChange' />
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { goalSplitList, deleteGoalSplit } from '@/api/processManager'
export default {
  name: 'mainTarget',
  data() {
    return {
      searchForm: {
        type: '',
        indicatorLevel: '',
        status: ''
      },
      typeList: [
        { id: 0, name: '年度目标' },
        { id: 1, name: '季度目标' },
        { id: 2, name: '月度目标' },
      ],
      statusList: [
        { id: 0, name: '预审批' },
        { id: 1, name: '部门审批' },
        { id: 2, name: '责任人审批' },
        { id: 3, name: '待考核' },
        { id: 4, name: '考核通过' },
        { id: 5, name: '考核不通过' },
        { id: 6, name: '整改中' },
        { id: 7, name: '复核通过' },
        { id: 8, name: '复核不通过' },
      ],
      tableData: [],
      limit: 10,
      total: 0,
      curPage: 1
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 获取数据
    getData() {
      goalSplitList({ limit: this.limit, isPage: 1, curPage: this.curPage, ...this.searchForm }).then(res => {
        this.tableData = res.body.data;
        this.total = res.body.cum
      })
    },
    // 下拉框选择的事件
    selectChange() {
      this.getData();
    },
    // 翻页
    curPageChange(val) {
      this.curPage = val;
      this.getData();
    },
    // 新增按钮
    add() {
      this.$router.push({
        path: 'targetSplitAdd'
      })
    },
    // 编辑
    edit(row) {
      this.$router.push({
        name: 'targetSplitAdd',
        params: { ...row }
      })
    },
    // 删除
    deleteList(row) {
      this.$confirm(`删除 ${row.indicatorName }, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteGoalSplit(row.id).then(res => {
          this.$message.success('删除成功');
          this.getData();
        })
      }).catch(() => {
        return      
      });
    },
    // 详情/审核
    detail(id) {
      this.$router.push(`splitDetail/${id}`)
    },
    // 跳转到考核
    examine(row) {
      this.$router.push({
        path: 'checkTargetAdd',
        query: {
          jumpStatus: true,
          id: row.id
        }
      })
    }
  }
}
</script>

<style scoped>
.innerBox {
  width: 100%;
  height: 100%;
  background: white;
}
.innerTitle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}
.innerTitle .screenBox {
  width: 30%;
  display: flex;
  justify-content: space-between;
}
</style>